angular.module("ainapp").controller("ApprovalStockJVController", [
    "app.config",
    "$scope",
    "LoginService",
    "AuthenticationService",
    "$state",
    "$stateParams",
    "MainService",
    "localStorageService",
    "$window",
    function (
        config,
        $scope,
        LoginService,
        AuthenticationService,
        $state,
        $stateParams,
        MainService,
        localStorageService,
        window
    ) {
        $scope.PageName = "Stock JV Approvals";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

         $scope.IsAdmin = false;
            if ($scope.TokenInfo.Role == "Admin" || $scope.TokenInfo.Role == "admin" || $scope.TokenInfo.Role == "SA" || $scope.TokenInfo.Role == "CA" || $scope.TokenInfo.Role == "0") {
                $scope.IsAdmin = true;
            }

        $scope.initKendoData = function () {
            $scope.ColumnSumamry = [
                {
                    field: "VoucherNo",
                    title: "Doc No #",
                    width: "120px"
                },
                {
                    field: "Date",
                    title: "Doc Date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    width: "120px"
                },
                {
                    field: "Warehouse.Name",
                    title: "Warehouse",
                    width: "100px"
                },
                {
                    field: "BillNo",
                    title: "BillNo",
                    width: "120px"
                },
                {
                    field: "TotalQuantity",
                    title: "Total Quantity",
                    width: "160px"
                },
                {
                    field: "TotalAmount",
                    title: "Total Amount",
                    width: "160px"
                },
                {
                    field: "Remarks",
                    title: "Remarks",
                    width: "120px"
                }
            ];

            $scope.CostCenters = [];
            MainService.CostCentersInReortVoucher("Stock JV").then(function (response) {
                $scope.CostCenters = response.data;

                angular.forEach($scope.CostCenters, function (e) {
                    var field = e.CostCenter.Name.replace(/ /g, "");
                    field = field.replace("&", "");
                    field = field.replace("/", "");
                    field = field.replace(".", "");

                    var clm = {
                        title: e.CostCenter.Name,
                        field: "CC" + field,
                        width: "100px"
                    };
                    $scope.ColumnSumamry.push(clm);
                });

                var options = {
                    title: "Options",
                    headerTemplate: "{{LanguageData.Options}}  ",
                    template:`<div ng-include="'templates/common/approvalButtons.html'"></div>`,
                    width: "200px",
                    sticky: true
                };

                $scope.ColumnSumamry.push(options);

                $scope.loadkendoData();
            });
        };

        $scope.init = function () {
            $scope.filter = {
                Keyword: "",
                CostKeyword: ""
            };
            $scope.initKendoData();
        };
        $scope.init();

        $scope.loadkendoData = function () {
            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        o.data.CostKeyword = $scope.filter.CostKeyword;
                        MainService.StockJVForApprovals(o.data).then(
                            function (response) {
                                o.success(response.data);
                            },
                            function (err) {
                                o.success(false);
                                toastr.error($scope.NetworkErrorLan);
                            }
                        );
                    }
                },
                change: function (data) {
                    if (data.items.length > 0) {
                        console.log(data);
                        var arr = [];
                        angular.forEach($scope.CostCenters, function (e) {
                            var field = e.CostCenter.Name.replace(/ /g, "");
                            field = field.replace("&", "");
                            field = field.replace("/", "");
                            field = field.replace(".", "");
                            arr.push("CC" + field);
                        });
                        angular.forEach(data.items, function (e) {
                            angular.forEach(arr, function (ar) {
                                angular.forEach(e.StockJVCosts, function (a) {
                                    var afield = a.ParentName.replace(/ /g, "");
                                    afield = afield.replace("&", "");
                                    afield = afield.replace("/", "");
                                    afield = afield.replace(".", "");
                                    afield = "CC" + afield;

                                    if (afield == ar) {
                                        e[ar] = a.CostCenterName;
                                    }
                                });
                            });
                        });
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date"
                            },
                            VoucherNo: {
                                type: "string"
                            },

                            TotalQuantity: {
                                type: "float"
                            },

                            "Customer.Name": {
                                type: "string"
                            },
                            CreatedDate: {
                                type: "date"
                            },
                            "CreatedBy.UserName": {
                                type: "string"
                            }
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true
                },
                filterable: true,

                columns: $scope.ColumnSumamry
            };
        };

        $scope.Edit = function (data) {
            $state.go("editStockJV", {
                VoucherId: data.Id
            });
        };

        $scope.refresh = function () {
            $scope.filter = {
                Keyword: "",
                Type: ""
            };
            $("#Sales-grid").data("kendoGrid").dataSource.read();
        };

        $scope.SearchKendo = function () {
            $("#Sales-grid").data("kendoGrid").dataSource.read();
        };

              $scope.Approve = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ApproveStockJV(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Resubmit = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ResubmitStockJV(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.RejectData = {
                VoucherId: "",
                Reason: "",
            };

            $scope.Reject = function (data) {
                $scope.RejectData = {
                    VoucherId: data.Id,
                    Reason: "",
                };

                $('#rejectModal').modal('show');
            }

            $scope.ConfirmReject = function () {

                if ($scope.RejectData.Reason == "") {
                    toastr.warning("Enter Reason");
                } else {
                    $scope.load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.RejectStockJV($scope.RejectData).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.refresh();
                            $('#rejectModal').modal('hide');
                        } else {
                            toastr.warning(response.data);
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function () {
                        toastr.error("NetworkError");
                        $scope.working = false;
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })
                }

            }

        $scope.View = function (data) {
            // $state.go("viewStockIssue", {
            //     VoucherId: data.Id
            // })

            var url = $state.href("viewStockJV", {
                VoucherId: data.Id
            });
            window.open(url, "_blank");
        };
    }
]);
